import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class TextH1 extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z" />
          <path d="M9.9,10.2h1.8V4.6h-1.4V4c0.4-0.1,0.7-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.7-0.3h0.8v6.8h1.6V11H9.9V10.2z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/TextH1.js